import close from '../assets/xmark.svg'
import warn from '../assets/warn.svg'
import error from '../assets/error.svg'
import success from '../assets/success.svg'

const Alert = ({ message, type, setShowAlert }) => {
  const bgColors = {
    error: 'bg-red-300',
    success: 'bg-green-300',
    warning: 'bg-yellow-200',
  }

  const icons = {
    warning: warn,
    error: error,
    success: success,
  }

  return (
    <div className={`p-3 ${bgColors[type]}`}>
      <img className="w-4 h-4 float-right cursor-pointer" src={close} alt="" onClick={() => setShowAlert(false)} />
      <div className="flex items-center gap-3 p-1 text-gray-700 font-medium">
        <img className="w-4 h-4 float-left" src={icons[type]} />
        <span>{message}</span>
      </div>
    </div>
  )
}

export default Alert
